import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_SEARCH_RESULT_COUNT,
  DEFAULT_SELECTED_PAGE_INDEX,
  FILE_TYPES,
} from "../../constants/metaData";

function extractValue(payload) {
  return payload !== null && payload !== ""
    ? payload.value !== null
      ? payload.value
      : []
    : [];
}

const initialState = {
  ifsDocuments: [],
  value: [],
  searchResultCount: DEFAULT_SEARCH_RESULT_COUNT,
  selectedPageIndex: DEFAULT_SELECTED_PAGE_INDEX,
  selectedFileType: FILE_TYPES.allFiles,
  searchedFileType: FILE_TYPES.allFiles,
  isIfsFileAccessible: false,
};

const searchSlice = createSlice({
  name: "documents/search",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_SEARCH", (state, action) => {
        state.value = extractValue(action.payload);
      })
      .addCase("ON_SEARCH_BACKEND", (state, action) => {
        state.ifsDocuments = extractValue(action.payload);
      })
      .addCase("ON_SET_SEARCH_INITIAL_STATE", (state, action) => {
        state.value = action.payload;
        state.searchResultCount = DEFAULT_SEARCH_RESULT_COUNT;
        state.selectedPageIndex = DEFAULT_SELECTED_PAGE_INDEX;
      })
      .addCase("ON_TEMPLATE_SEARCH", (state, action) => {
        state.value = extractValue(action.payload);
      })
      .addCase("ONEDRIVE_SEARCH", (state, action) => {
        state.value = extractValue(action.payload);
      })
      .addCase("ON_FILE_TYPE_SELECTED", (state, action) => {
        state.selectedFileType = action.payload;
      })
      .addCase("ON_FILE_ACCESS_STATUS", (state, action) => {
        state.isIfsFileAccessible = action.payload;
      })
      .addCase("ON_SEARCHED_FILE_TYPE", (state, action) => {
        state.searchedFileType = action.payload;
      });
  },
});

export default searchSlice.reducer;
